import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sso-logout',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './sso-logout.component.html',
  styleUrl: './sso-logout.component.css'
})
export class SsoLogoutComponent implements OnInit {
  isSelected: any;
  buttonText: any;
  lang: any;

  constructor(private router: Router, private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.addLangs(['en', 'jp']);
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      this.lang = localStorage.getItem('site_lang') ?? 'jp';
      this.isSelected = this.lang;
      localStorage.setItem('site_lang', this.lang);
      this.translate.use(this.lang);
    }

    if (this.lang == 'en') {
      this.buttonText = 'English';
    } else {
      this.buttonText = 'Japanese';
    }
  }

  switchLanguage(lang: string) {
    this.isSelected = lang;
    this.lang = lang;
    this.buttonText = lang == 'en' ? 'English' : 'Japanese';
    localStorage.setItem('site_lang', lang);
    this.translate.use(lang);
  }

  login() {
    this.router.navigate(['login-sso']);
  }
}
